import { createTheme } from '@mui/material/styles'

import { GenericTheme } from 'types/GenericThemeMui'
import { isMobileView } from 'lib/GlobalConstants'

const filterWidth = isMobileView ? '100%' : 250
const customFilterWidth = isMobileView ? '100%' : '29.063rem'

const DefaultGenericTheme = createTheme({
  GenericTheme: {
    filterWrapperWidth: {
      width: filterWidth,
    },
    dynamicFilterWrapperWidth: {
      width: customFilterWidth,
    },
    textFieldCSSToRaiseZindex: {
      width: '29.063rem', // default width
      background: 'white',
      zIndex: 3,
      position: 'absolute',
    },
    zeropaddingAndMargin: {
      padding: '0rem',
      margin: '0rem',
    },
  },
} as GenericTheme)

export default DefaultGenericTheme
